export default __webpack_public_path__ + "static/media/video-call-ring.f2973fe3.mp3";